// hooks/useExportClientsXLSX.ts
import { useCallback } from "react";
import * as XLSX from "xlsx";
import { translations } from "./translations"; // ajuste conforme o caminho real
import { useTranslation } from "hooks";

export function useExportClientsXLSX() {
  const { getTranslation } = useTranslation(translations);

    const exportToXLSX = useCallback((dados: any[]) => {
    if (!dados || dados.length === 0) {
      alert("Não há dados para exportar");
      return;
    }

    const nameFile = "RELATÓRIO-CLIENTES.xlsx";
    const file = XLSX.utils.book_new();

    const wsData = dados.map((client) => [
      client.id || "---",
      client?.cnpj || "---",
      client.company_name || "---",
      client.trade_name || "---",
      client.inscricao_estadual || "---",
      client.phone_number || "---",
      client.email || "---",
      client.address_zipcode || "---",
      client.address_street || "---",
      client.address_number || "---",
      client.address_neighborhood || "---",
      client.address_state || "---",
      client.address_city || "---",
      (Array.isArray(client.clientCodes)
        ? client.clientCodes.map((c: any) => c.client_code).join(", ")
        : "") || "---",
      client.general_client_type_id === 1
        ? "STAR"
        : client.general_client_type_id === 2
        ? "PLATINUM"
        : client.general_client_type_id === 3
        ? "GOLD"
        : client.general_client_type_id === 4
        ? "SILVER"
        : "---",
      client?.clientCodes?.[0]?.latitude ?? "---",
      client?.clientCodes?.[0]?.longitude ?? "---",
      client.general_country_id === 32
        ? "BR"
        : client.general_country_id === 52
        ? "CO"
        : client.general_country_id === 12
        ? "AR"
        : client.general_country_id === 174
        ? "PE"
        : "EX",
        client.observation || "---",
        client?.businessLine?.description || "---",
        client?.businessLineUnit?.name || "---",
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        getTranslation("id"),
        getTranslation("cnpjCpf"),
        getTranslation("razaoSocial"),
        getTranslation("trade_name"),
        getTranslation("inscricao_estadual"),
        getTranslation("phone_number"),
        getTranslation("email"),
        getTranslation("address_zipcode"),
        getTranslation("address_street"),
        getTranslation("address_number"),
        getTranslation("address_neighborhood"),
        getTranslation("address_state"),
        getTranslation("address_city"),
        getTranslation("codigoSap"),
        getTranslation("customerSegment"),
        getTranslation("latitude"),
        getTranslation("longitude"),
        getTranslation("pais"),
        getTranslation("observation"),
        getTranslation("businessLine"),
        getTranslation("businessLineUnit"),
      ],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(file, worksheet, "Dados");
    XLSX.writeFile(file, nameFile);
  }, [getTranslation]);

  return { exportToXLSX };
}
